import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { ModalActiveService } from 'app/core/services/modalActive.service';
import { DirectivesModule } from '../directives/directives.module';
import { ServicesModule } from '../services/services.module';
import { T2LoadingService } from '../trip2-theme/components/t2-loading/t2-loading.service';
import { Trip2ThemeModule } from '../trip2-theme/trip2-theme.module';
import { SearchLocationTripModule } from './A2-utils/search-location-trip/search-location-trip.module';
import { ChangePasswordModule } from './change-password/change-password.module';
import { ImportSettingsModule } from './import-settings/import-settings.module';
import { ImportTemplateModule } from './import-template/import-template.module';
import { PagesRoutingModule } from './pages-routing.module';
import { UsersModule } from './users/users.module';
import { NoteTemplateModule } from './note-template/note-template.module';


@NgModule({
  imports: [
    CommonModule,
    PagesRoutingModule,
    UsersModule,
    NoteTemplateModule,
    ChangePasswordModule,
    SearchLocationTripModule,
    DirectivesModule,
    AgGridModule,
    FormsModule,
    Trip2ThemeModule,
    ServicesModule,
    ImportTemplateModule,
    ImportSettingsModule
  ],
  providers: [T2LoadingService, ModalActiveService]
})
export class PagesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts